import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, MapPin, Users, Settings, Wrench, Building2 } from 'lucide-react';
import { VALUES, STRENGTHS, COMPANY } from '../mock';
import PartnerBanner from '../components/PartnerBanner';
import CTASection from '../components/CTASection';

const STRENGTH_ICONS = [Wrench, ShieldCheck, Settings, Users, Building2, MapPin];

export default function About() {
  return (
    <div>
      <section className="pt-36 pb-16 bg-grad-hero relative overflow-hidden">
        <img src="/logos/logo-green.png" alt="" aria-hidden="true" className="absolute -left-24 -bottom-10 w-[420px] opacity-[0.05]" />
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center relative">
          <div>
            <p className="eyebrow">À propos</p>
            <h1 className="font-display text-5xl md:text-6xl lg:text-7xl mt-5 leading-[1.05] text-gray-900">Notre engagement, votre <span className="italic-accent">tranquillité.</span></h1>
            <p className="mt-6 text-gray-600 leading-relaxed">En tant que spécialiste pour les solutions énergétiques durables en Suisse romande, l'entreprise Suisse Energies Renouvelables accompagne les particuliers et les entreprises dans leur rénovation énergétique grâce à l'installation d'équipements fiables et performants.</p>
            <p className="mt-4 text-gray-600 leading-relaxed">Notre objectif est simple : permettre aux propriétaires immobiliers romands d'accéder à l'indépendance énergétique, sécuriser leur énergie, faire des économies sur leurs factures et obtenir un taux d'autoconsommation optimal.</p>
          </div>
          <div className="relative">
            <div className="rounded-3xl overflow-hidden aspect-[5/6] shadow-xl bg-[#f1f1f1]">
              <img src="/photos/siege-hermance.png" alt="Siège Suisse Energies Renouvelables - Hermance" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-8 left-6 bg-[#125082] text-white p-6 rounded-2xl shadow-xl max-w-[300px]">
              <div className="flex items-center gap-2 mb-1">
                <p className="text-[10px] tracking-widest uppercase text-[#80b23f] font-semibold">Siège</p>
                <Building2 className="w-3.5 h-3.5 text-[#80b23f]" />
              </div>
              <p className="font-display text-2xl mt-1 text-white">Hermance (GE)</p>
              <p className="text-xs text-white/75 mt-1">{COMPANY.address}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <p className="eyebrow text-center block">Nos valeurs</p>
          <h2 className="font-display text-4xl md:text-5xl mt-4 text-center text-gray-900">Trois engagements <span className="italic-accent">qui nous définissent.</span></h2>
          <div className="grid md:grid-cols-3 gap-7 mt-14">
            {VALUES.map((v, i) => (
              <div key={i} className="relative bg-[#f1f1f1] p-9 rounded-2xl overflow-hidden">
                <img src="/logos/logo-blue.png" alt="" aria-hidden="true" className="absolute -right-8 -bottom-8 w-40 opacity-[0.07]" />
                <div className="relative">
                  <span className="step-number text-4xl">0{i+1}</span>
                  <h3 className="font-display text-2xl text-gray-900 mt-3 mb-3">{v.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{v.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#125082] text-white relative overflow-hidden on-dark">
        <img src="/logos/logo-white.png" alt="" aria-hidden="true" className="absolute -right-32 -bottom-20 w-[500px] opacity-[0.05]" />
        <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
          <p className="eyebrow !text-[#80b23f]">Nos forces & atouts</p>
          <h2 className="font-display text-4xl md:text-5xl mt-4 max-w-3xl leading-tight">Travailler avec nous c'est <span className="italic-accent">l'assurance d'un projet maîtrisé.</span></h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
            {STRENGTHS.map((s, i) => {
              const I = STRENGTH_ICONS[i] || ShieldCheck;
              return (
                <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-7 hover:bg-white/10 transition-colors">
                  <span className="w-12 h-12 rounded-full bg-[#80b23f] flex items-center justify-center mb-5"><I className="w-5 h-5" /></span>
                  <h3 className="font-display text-xl mb-2">{s.title}</h3>
                  <p className="text-sm text-white/70 leading-relaxed">{s.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <PartnerBanner />
      <CTASection />
    </div>
  );
}
